/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { COLOR } from 'constant'
import { getIsNoDataByMetricName } from 'utils/getMetricListByType'
import { RoundedButtonFullWidth } from '../LeftPanel/LeftPanel.styled'
import { useAppSelector } from 'hooks'
import { chartType, metricType } from 'store/AIMetricOT/reducerSlice'
import { makeStyles } from '@mui/styles'
import { Box } from '@mui/material'
import { SvgCarretDownIcon } from 'components/common/LeftPanel/LeftPanel.styled'
import { MetricType } from 'types'

const useStyles = makeStyles({
  option: {
    '&:hover': {
      backgroundColor: `${COLOR.TEXT} !important`,
    },
  },
})

const MetricSearchDropdown: React.FC<{
  text: string
  selectedShowMetric: string | undefined
  dropdownMetricType: MetricType
  id: string
  disabled: boolean
  size: any
  width?: number
  height?: number
  fontSize?: number
  handleChangeDropdown: Function
  handleSetMetricType: Function
  data: {
    [metricKey: string]: any
    isNoData: boolean | false
  }[]
}> = ({
  text,
  selectedShowMetric,
  dropdownMetricType,
  id,
  disabled,
  size,
  height = 40,
  handleChangeDropdown = () => { },
  handleSetMetricType = () => { },
  fontSize = 16,
  data,
}) => {
    const currentMetricType = useAppSelector(metricType)
    const currentChartType = useAppSelector(chartType)
    const [isBarChart, setIsBarChart] = React.useState<boolean>(true)
    React.useEffect(() => {
      setIsBarChart(!isBarChart)
    }, [currentChartType])

    const onChange = (event: React.SyntheticEvent, valueParam: any) => {
      handleChangeDropdown(valueParam, dropdownMetricType)
    }
    const styles = useStyles()

    return (
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
        <RoundedButtonFullWidth
          style={{
            background: currentMetricType === dropdownMetricType ? COLOR.DARK : COLOR.LIGHT,
            color: currentMetricType === dropdownMetricType ? COLOR.TEXT : COLOR.NAVY,
            opacity: disabled ? 0.6 : 1
          }}
          onClick={() => handleSetMetricType(dropdownMetricType)}
          disabled={disabled || currentMetricType === dropdownMetricType}
        >
          {text}
        </RoundedButtonFullWidth>
        <Autocomplete
          disablePortal
          id={id}
          popupIcon={<SvgCarretDownIcon iconColor={COLOR.CARRET} width='20px' height='20px' />}
          size={size}
          classes={{
            option: styles.option,
          }}
          // isOptionEqualToValue={(option, value) => option.value === value.value}
          disabled={disabled || currentMetricType !== dropdownMetricType}
          disableClearable
          sx={{
            opacity: disabled ? 0.6 : 1,
            margin: 0,
            ml: 1,
            width: '100%',
            '& .MuiAutocomplete-inputRoot': {
              background: COLOR.LIGHT,
              border: 'none',
              height: `${height}px !important`,

              borderRadius: '30px !important',
              fontSize: `${fontSize}px !important`,
              fontFamily: 'CircularStdBook !important',
              paddingTop: height < 40 ? '3px !important' : '6px !important',
            },
            '& .MuiAutocomplete-popupIndicator': {
              transform: 'none',
              background: 'transparent',
              marginTop: '2px',
              '&:focus, &:active': {
                transform: 'rotate(90deg)',
                background: 'transparent',
              },
              '&:hover': {
                backgroundColor: 'transparent',
              },
            },
            '& .MuiAutocomplete-popupIndicatorOpen': {
              transform: 'rotate(90deg)',
            },
          }}
          value={currentMetricType === dropdownMetricType ? selectedShowMetric : ''}
          onChange={onChange}
          options={data?.map((mt) => Object.values(mt)[0])}
          getOptionDisabled={(option) => {
            return currentChartType === 'bar' ? getIsNoDataByMetricName(data, option) : false
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                style: { fontSize: fontSize },
              }}
              value={selectedShowMetric}
            />
          )}
        />
      </Box>
    )
  }
export default MetricSearchDropdown
